<template>
  <div class="input">
    <div class="input-label">都道府県</div>
    <div class="input-group">
      <input-select
        :option="prefecture"
        :options="prefectures"
        @select="(o) => prefecture = o" />
    </div>
  </div>
</template>

<script>
import InputSelect from '@/components/Input/Select'

export default {
  components: {
    InputSelect,
  },

  created: function () {
    let country = this.$store.state.user.country
    this.$store.dispatch('country/retrievePrefectures', country)
  },

  computed: {
    prefectures: function () {
      return this.$store.getters['country/prefectures']
    },

    prefecture: {
      get: function () {
        return this.$store.state.user.prefecture
      },
      set: function (value) {
        this.$store.commit('user/setPrefecture', value)
      }
    }
  }
}
</script>


<style lang="scss" scoped>
@import '@/styles/_form.scss';
.select-suit {
  @include input-select
  width: 30%;

  &-frame {
    @include input-select-frame;
  }

  &-option {
    @include input-select-option;
  }
}
</style>
